// Micro pSBC - Ultra Fast and Small Shade Blend Convert - Version 4.1 - 01/7/2021
// https://github.com/PimpTrizkit/PJs/blob/master/pSBC-Micro.js

// returns shade of given rgb color string (c0) based on percentage (p)
// darkening: p >= -1 && p < 0
// lightning: p > 0 && p <= 1
// RGB_Log_Shade(-0.5, 'rgb(255, 255, 255)') -> 'rgb(180,180,180)'
export const RGB_Log_Shade=(p:number,c0:string)=>{
	var i=parseInt,r=Math.round,[a,b,c,d]=c0.split(","),n=p<0,t=n?0:p*255**2,P=n?1+p:1-p;
	return"rgb"+(d?"a(":"(")+r((P*i(a[3]=="a"?a.slice(5):a.slice(4))**2+t)**0.5)+","+r((P*i(b)**2+t)**0.5)+","+r((P*i(c)**2+t)**0.5)+(d?","+d:")");
}